module.exports = __webpack_public_path__ + "img/logo-att.331aa18d.png";